export default __webpack_public_path__ + "static/media/business_continuity_management_and_operational_resilience.17937f66.png";